import { render } from "./addwxPay.vue?vue&type=template&id=c76befbe"
import script from "./addwxPay.vue?vue&type=script&lang=js"
export * from "./addwxPay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__